import React, { useState } from 'react'
import { Box, List, ListItem, ListItemAvatar, ListItemButton, ListItemText} from '@mui/material'
import FolderIcon from '@mui/icons-material/Folder';
import { useNavigate } from 'react-router-dom';
import ListItemIcon from '@mui/material/ListItemIcon';

// home page sidebar

function renderRow(props) {
	const { index, style } = props;

	return (
		<ListItem style={style} key={index} component="div" disablePadding>
			<ListItemButton>
				<ListItemText primary={`Item ${index + 1}`} />
			</ListItemButton>
		</ListItem>
	);
}

export default function Sidebar(props) {
	const { projects } = props
	const navigate = useNavigate()

	const onClickAll = () => navigate("activities", { state: { limit: -1} })

	const onClickProject = projectName => () => navigate(`project/${encodeURIComponent(projectName)}`, { state: { projectName } })
	
	const [selectedIndex, setSelectedIndex] = useState(-1);

	const handleListItemClick = (event, index) => {
	  setSelectedIndex(index);
	};

	const onClickRecent = () => navigate("activities");
	
	//#E8FDFF
	//#E5F5FF
	//#A4D5DC
	//#FFECB3
	//#F5B85F
	//#ECBE8C
	//#EFF9FF
	//#FFF8E5
	return (
		<div>
			<Box sx={{ flexShrink: 2, backgroundColor: "#FFF8E5", minWidth: "100%", height: "100vh" , overflow: "auto"}}>
				<List sx={{backgroundColor: "#FFF8E5"}} component="nav" aria-label="main mailbox folders">
					<ListItem>
						<ListItemText primary="Active Projects" />
					</ListItem>

					<ListItemButton selected={selectedIndex === -1} onClick={(event) => {handleListItemClick(event, -1); onClickRecent()}} >
						<ListItemAvatar>
							<ListItemIcon>
								<FolderIcon />
							</ListItemIcon>
						</ListItemAvatar>
						<ListItemText primary="Recent" />
					</ListItemButton>

					<ListItemButton selected={selectedIndex === -2}  onClick={(event) => {handleListItemClick(event, -2); onClickAll()}} >
						<ListItemAvatar>
							<ListItemIcon>
								<FolderIcon />
							</ListItemIcon>
						</ListItemAvatar>
						<ListItemText primary="All" />
					</ListItemButton>

					{
						projects.map((project, idx) =>
						(
							<ListItemButton  selected={selectedIndex === idx}  key={project.id} onClick={(event) => {handleListItemClick(event, idx); onClickProject(project.id)()}} >
								<ListItemIcon>
									<FolderIcon />
								</ListItemIcon>
								<ListItemText primary={project.name} secondary={project.year}/>
							</ListItemButton>

						)
						)
					}
				</List>
			</Box>
		</div>
	)
}
